import { useEffect, useState } from "react";
import profileImg from "../../assets/images/profile.png";
// import Editor from "react-simple-wysiwyg";
import AuthService from "../../services/auth.service";
import moment from "moment";
import HolidayShiftService from "../../services/holidayshift.service";
import { useStateContext } from "../../contexts/ContextProvider";

const RejectHolidayShift = ({
  selectedData,
  reject,
  setReject,
  setSuccess,
  setHeading,
  fetchData,
}) => {
  // const [html, setHtml] = useState("");

  const user = AuthService.getCurrentUser();

  const { getNameInitials } = useStateContext();

  const [approvedDayslist, setApprovedDayslist] = useState([]);

  useEffect(() => {
    setApprovedDayslist(selectedData && selectedData.reqdetails);
  }, [selectedData]);

  const setIsApproved = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.rdate === date
          ? { ...item, isApproved: item.isApproved === "1" ? "0" : "1" }
          : item
      )
    );
  };

  // console.log("approvedDayslist", approvedDayslist);

  // const onChange = (e) => {
  //   setHtml(e.target.value);
  // };

  const isApprovedCount =
    approvedDayslist &&
    approvedDayslist
      .filter((item) => item.isApproved === "1")
      .reduce((sum, item) => sum + (item.workday === "0.5" ? 0.5 : 1), 0);

  const approveHolidayShiftRequest = () => {
    const payload = {
      empid: selectedData && selectedData.empid,
      requestid:
        selectedData && selectedData.reqdetails[0].requestid.toString(),
      roleid: user && user.role,
      isApproved: "2",
      actionBy: user && user.empid,
      actionOn: moment(new Date()).format("YYYY-MM-DD"),
      reqdetails: approvedDayslist.map((item) => ({
        rdate: item.rdate,
        requestid: item.requestid.toString(),
        roleid: user && user.role,
        isApproved: "2",
      })),
    };
    // console.log("paylaod", payload);

    HolidayShiftService.actiononHolidayShift(payload)
      .then((resp) => {
        if (resp.data) {
          setSuccess(true);
          setHeading("Holiday Shift Request Rejected Succesfully");
          fetchData();
          setReject(false);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${reject ? "sortByModal visible" : "sortByModal hidden"}`}
      >
        <div className="flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Reject Leave request</span>
            </div>

            <div className="leaveModalHeading">
              <div className="row">
                <div className="col-lg-6">
                  <div className="left-flex">
                    <div className="profile">
                      {selectedData && selectedData.profile ? (
                        <img src={profileImg} width={40} alt="profileImg" />
                      ) : (
                        <>
                          <div className="circle">
                            <span>{getNameInitials(selectedData.name && selectedData.name)}</span>
                          </div>
                        </>
                      )}
                      <div className="profile-info">
                        <span className="name">
                          {selectedData && selectedData.name}
                        </span>
                        <span className="desig"></span>
                      </div>
                    </div>
                    <div className="csort">
                      <div className="d-flex flex-column">
                        {/* {user.role === "1" && (
                          <label htmlFor="leaveType" className="form-label">
                            Approved Leave Days by RM - Days
                          </label>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>From Time</th>
                  <th>To Time</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(approvedDayslist)
                  ? approvedDayslist.map((item) => {
                      return (
                        <tr>
                          <td>{item.rdate}</td>
                          <td>{item.fromtime} AM</td>
                          <td>{item.totime} PM</td>
                          <td>{item.workinghrs} Hours</td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <td></td>
                  <td></td>
                  <td>{selectedData && selectedData.workinghrs} Hours</td>
                </tr>
              </tfoot>
            </table>

            {/* <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Remark
              </label>
              <Editor value={html} onChange={onChange} />
            </div> */}
          </div>
          <div className="sort-action">
            <button
              className="btn btn-reject"
              onClick={approveHolidayShiftRequest}
            >
              Reject
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectHolidayShift;
